import React, { useState, useEffect, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TrendTable from './Table';
import Visualis from './Visualis';
import { useIntl } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import { tableDataFormatKMB } from '@/pages/intelligence/utils/commonUtils';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    lineData,
    cardStatus,
    asForDate,
    dateType,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    pageSortAttr,
    onTableSortChage,
    metricSegVal,
    setMetricSegVal,
    entityType,
    dataSource,
    lineXAxisData,
    trendLoading,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  const { rpdSegementOptions, rpdSegementTitleObj } = useMobileOptionList();

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  const [countValue, setCountValue] = useState<string | number>('');
  const [activeLineData, setActiveLineData] = useState([]);
  const segementTitle = useMemo(() => rpdSegementTitleObj[metricSegVal], [metricSegVal]);

  useEffect(() => {
    const activeSegData = lineData?.filter((t: any) => {
      return t.metric === metricSegVal;
    })[0];
    setActiveLineData(activeSegData?.history);
    const countValue = Math.max(
      activeSegData?.avg_by_line,
      activeSegData?.max_by_line,
      activeSegData?.total_by_line,
    );

    setCountValue(tableDataFormatKMB(countValue));
  }, [metricSegVal, lineData]);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={`RPD ${formatMessage({ id: `dbi_detail_trend` })}`}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-trends-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context dbi-mobileGames-title-custom"
        title={`RPD ${formatMessage({ id: `dbi_detail_trend` })}`}
        subTitle={`${segementTitle} : ${countValue}`}
        rightText={
          earliestDay ? `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}` : ''
        }
        rightTip={earliestDay ? formatMessage({ id: `dbi_detail_earlistdate_info` }) : ''}
        disableChartType={['bar', 'pie']}
        activeTab={'line'}
      >
        <Segment
          value={metricSegVal}
          onChange={(value) => {
            /** 切换segement时，更新聚合数据，更新可视化数据 */
            setMetricSegVal(value);
          }}
          options={rpdSegementOptions}
        />
        <div className="trends-card-line">
          <Visualis
            lineData={lineData}
            // lineData={activeLineData}
            chartSegment={metricSegVal} /** 用于表格展示排序 */
            chartType={'line'}
            dateType={dateType}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            dataSource={dataSource}
            lineXAxisData={lineXAxisData}
            trendLoading={trendLoading}
            enableOpinionEventAnnotation={enableOpinionEventAnnotation}
            controlledEventAnnotation={controlledEventAnnotation}
          />
        </div>
        <TrendTable
          tableData={tableData}
          chartSegment={metricSegVal} /** 用于表格展示排序 */
          asForDate={asForDate}
          dateType={dateType}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          entityType={entityType}
          source={dataSource}
        />
      </CardSlotV2>
    </div>
  );
};
export default TrendsCard;
